import { Module } from "vuex";
import type { RootState } from "@/store";

export interface AnalyticsState {
  visitCount: number;
}

const analyticsModule: Module<AnalyticsState, RootState> = {
  namespaced: true,
  state: () => ({
    visitCount: 0,
  }),
  getters: {},
  mutations: {
    SET_VISIT_COUNT(state, value: number) {
      state.visitCount = value;
    },
  },
  actions: {
    incrementVisitCount({ state, commit }) {
      commit("SET_VISIT_COUNT", Number(state.visitCount || 0) + 1);
    },
  },
};

export default analyticsModule;
